import {
    Container,
    InnerCard,
    ToUnlock,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/Card.styled";
import type { CardStatus } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/utils/consts";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { getCardConfig } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/utils/getCardConfig";

interface ICardProps {
    cardIndex: number;
    invitationCount: number;
    packageItem: IPackage;
    status: CardStatus;
}

const Card = ({ invitationCount, packageItem, status, cardIndex }: ICardProps) => {
    const remainingReferrals = packageItem.ReferralsNumber - invitationCount;
    const { cardComponent, unlockText } = getCardConfig(packageItem, status, remainingReferrals, cardIndex);
    const isDisabled = status === "disabled";

    return (
        <Container isDisabled={isDisabled}>
            <InnerCard>{cardComponent}</InnerCard>
            <ToUnlock>{unlockText}</ToUnlock>
        </Container>
    );
};

export default Card;
